import { matchPath } from '@direct-frontend/modules-router';
import { productCardRoute } from '#shared/lib/routes';
import {
    DEFAULT_PRODUCT_FORM_SECTION,
    PRODUCT_FORM_SECTION_IDS,
    PRODUCT_FORM_SECTIONS,
    type ProductFormSection,
} from './productFormSections';

export const resolveProductFormSection = (pathname: string): ProductFormSection =>
    PRODUCT_FORM_SECTION_IDS.find((section) => matchPath(PRODUCT_FORM_SECTIONS[section].route.route, pathname)) ??
    DEFAULT_PRODUCT_FORM_SECTION;

export const getProductFormSectionHref = ({
    productId,
    variantId,
    search,
    section,
}: {
    productId: string;
    variantId?: string;
    search: string;
    section: ProductFormSection;
}): string | undefined => {
    if (!variantId) {
        return section === DEFAULT_PRODUCT_FORM_SECTION
            ? `${productCardRoute.getUrl({ params: { productId } })}${search}`
            : undefined;
    }

    const pathname = PRODUCT_FORM_SECTIONS[section].route.getUrl({ params: { productId, variantId } });

    return `${pathname}${search}`;
};
